module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "Background2.35e455bf.png";